import type { InjectionKey, Ref } from "vue";

/**
 * Linked waivers of the selected order, provided by the aside order summary to
 * the link waiver modal. The backend is the source of truth: the modal never
 * edits the ids, it asks for a refresh after a link or unlink.
 */
export interface LinkedWaiversContext {
  /** Signed waiver ids linked to the selected order. */
  linkedWaiverIds: Ref<string[]>;
  /**
   * Re-read the selected order's linked waivers. Never throws: a failed read
   * is journaled and the previous ids are kept.
   *
   * @param retries not-synced retries, see getOrderLinkedWaiverIds
   */
  refresh: (retries?: number) => Promise<void>;
}

export const LINKED_WAIVERS_KEY: InjectionKey<LinkedWaiversContext> =
  Symbol("linkedWaivers");
